import Head from "next/head";
import { fromUrl, toUrl } from "common/src/Aperture.bs";
import { make as TraitPage } from "../../src/stats/TraitPage.bs";
import { make as TraitsPage } from "../../src/stats/TraitsPage.bs";
import { getApertures } from "../../utils/static-paths";
import { renderFull, toApiUrl as patchToUrl } from "common/src/Patch.bs";
import { fromUrlName } from "common/src/tft-static/Sd.ts";
import { statsSet } from "common/src/Config.ts";
import * as T from "common/src/bindings/Translation2.ts";

export default function Traits({
  traitId,
  traitRank,
  traitData,
  aperture,
  statsData,
}) {
  if (traitId != null) {
    return (
      <>
        <Head>
          <title>{`${T.traits(
            traitId,
          )} TFT Stats - Synergies & Counters Set 18 Patch ${renderFull(
            aperture.patch,
          )}`}</title>
        </Head>
        <TraitPage
          traitId={traitId}
          traitRank={traitRank}
          traitData={traitData}
        />
      </>
    );
  } else {
    return (
      <>
        <Head>
          <title>{`TFT Traits Stats - Best Traits for Set 18 Patch ${renderFull(
            aperture.patch,
          )}`}</title>
        </Head>
        <TraitsPage statsData={statsData} />
      </>
    );
  }
}

export async function getStaticPaths() {
  const params = getApertures();
  return {
    paths: [],
    fallback: "blocking",
  };
}

export async function getStaticProps({ params, locale }) {
  const traitId = fromUrlName(params.slug?.[0], statsSet);
  if (traitId != null) {
    const traitRank = Number(params.slug[1]);
    const aperture = fromUrl(params.slug.slice(2));

    const traitResp = await fetch(
      `https://d3.tft.tools/stats2/trait/${
        aperture.queue
      }/${traitId}/${traitRank}/${patchToUrl(aperture.patch)}/${
        aperture.rankGroup
      }`,
    );
    const traitData = await traitResp.json();

    return {
      props: {
        aperture,
        traitId,
        traitRank,
        traitData,
      },
      revalidate: 3600,
    };
  } else {
    const aperture = fromUrl(params.slug || []);
    const statsResp = await fetch(
      `https://d3.tft.tools/stats2/general/${aperture.queue}/${patchToUrl(
        aperture.patch,
      )}/${aperture.rankGroup}`,
    );
    const statsData = await statsResp.json();

    return {
      props: {
        aperture,
        statsData,
      },
      revalidate: 3600,
    };
  }
}
